import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbToastrService,
} from "@nebular/theme";

import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import ReportSpam from "../../models/report-spam.model";

import { ReportSpamService } from "../../services/report-spam.service";
import { replace, remove, clone, find } from "lodash";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: "ngx-view-reports",
  styleUrls: ["./view-reports.component.scss"],
  templateUrl: "./view-reports.component.html",
})
export class ViewReportsComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() mode?: string = "admin"; //admin / develop
  reports?: ReportSpam[] = [];
  display?: ReportSpam[] = [];

  pageSize = 3;
  cursor: any;
  done = false;
  loading = false;
  submitted = false;

  strSearch = "";
  uid = "anonymous";

  constructor(
    private userService: UserService,
    private reportService: ReportSpamService,
    private router: Router,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
        } else {
          this.uid = "anonymous";
        }
        this.getReports();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getMore() {
    this.pageSize = 12;
    this.getReports();
  }

  search() {
    this.strSearch = this.strSearch.toLowerCase();
  }

  getReports(): void {
    this.loading = true;

    let subscribe: any;
    if (this.mode == "admin") {
      subscribe = this.reportService.getReports(this.pageSize, this.cursor);
    } else {
      subscribe = this.reportService.getMyReports(
        this.uid,
        this.pageSize,
        this.cursor
      );
    }

    subscribe
      .then((querySnapshot) => {
        if (querySnapshot.docs.length > 0) {
          this.cursor = querySnapshot.docs[querySnapshot.docs.length - 1];

          querySnapshot.forEach((doc) => {
            let data = new ReportSpam();
            data = doc.data();
            data.id = doc.id;
            data.createdOn = convertTimestamp(doc.data().createdOn);

            //get icon
            switch (data.mode) {
              case "courses":
                data.iconMode = "book-open-outline";
                data.navigateUrl = "/course/" + data.refId;
                break;
              case "lecture-contents":
                data.iconMode = "file-text-outline";
                data.navigateUrl = "/lecture/" + data.refId;
                break;
              case "qnas":
                data.iconMode = "question-mark-circle-outline";
                data.navigateUrl = "/qna/" + data.refId;
                break;
              case "quizzes":
                data.iconMode = "layers-outline";
                data.navigateUrl = "/quiz/" + data.refId;
                break;
              case "comments":
                data.iconMode = "message-square-outline";
                data.navigateUrl = "";
                break;
              default:
                if (data.mode.includes("courses/")) {
                  data.iconMode = "book-open-outline";
                  data.navigateUrl = "/course/" + data.mode.split("/")[1];
                } else if (data.mode.includes("qnas/")) {
                  data.iconMode = "question-mark-circle-outline";
                  data.navigateUrl = "/qna/" + data.mode.split("/")[1];
                } else {
                  data.iconMode = "globe-outline";
                  data.navigateUrl = "";
                }

                break;
            }

            let item = find(this.reports, ["id", data.id]);
            if (item) {
              item = data;
            } else {
              this.reports.push(data);
            }
          });

          this.display = [...this.reports];
        } else {
          this.cursor = null;
          this.done = true;
        }

        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
      });
  }

  onDelete(value) {
    remove(this.reports, (e) => {
      return e.id == value;
    });
    this.display = [...this.reports];
  }

  openTestQuiz(item: ReportSpam) {
    //this.router.navigateByUrl(`/quiz/${item.id}`);
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/quiz/${item.id}`])
    );
    window.open(url, "_blank");
  }

  //Control event
  onSearch(): void {
    this.display = this.reports.filter(
      function (item) {
        return item.refTitle.toLowerCase().includes(this.title);
      },
      { title: this.strSearch }
    );
  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
